// hooks/useGroupBalanceStats.ts
import { useQuery } from "@tanstack/react-query";

import { GroupBalanceStats } from "../types/GroupBalanceStats";
import useApi from "../api/hooks/useApi.ts";

export const useGroupBalanceStats = (groupId?: string) => {
  const { requestFn } = useApi<GroupBalanceStats>({
    url: "/groupBalance",
    method: "GET",
  });

  return useQuery({
    queryKey: ["groupBalance", groupId],
    queryFn: () => requestFn({ groupId }),
    enabled: !!groupId,
  });
};
